import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import { AuthContext } from "../../../contexts/Auth";
import { Button } from "../../button/Button";
import { Curtain } from "../../misc/Curtain";
import { ErrorScreen } from "../../screens/ErrorScreen";

/**
 * Show login form if not logged in on this route or
 * show restricted message if user not authorized.
 */
export const AuthenticatedRoute = ({ element, roles }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { busyAuthenticating, me } = useContext(AuthContext);
    const [authorized, setAuthorized] = useState(null);

    useEffect(() => {
        // Check if busy
        if (busyAuthenticating) {
            return;
        }

        // Check authorization
        let isAuthorized = true;
        if (roles && me?.user.roles?.length) {
            const rolesList = roles.split(",");
            for (let i = 0; i < rolesList.length; i++) {
                if (me?.user.roles.indexOf(rolesList[i]) < 0) {
                    isAuthorized = false;
                }
            }
        } else if (me?.user?.roles) {
            isAuthorized = true;
        } else {
            isAuthorized = false;
        }
        setAuthorized(isAuthorized);

        // Not logged in
        if (!me && !location.pathname.startsWith("/login")) {
            console.log("[VP] Redirecting to login");
            navigate("/login", {
                replace: true,
                state: {
                    from: location.pathname
                }
            });
        }
    }, [busyAuthenticating, me, roles, navigate, location.pathname]);

    // Check if authorized
    if ((busyAuthenticating && !me) || authorized === null) {
        return <Curtain label="Authenticating" />;
    } else if (!authorized || !me) {
        return (
            <ErrorScreen
                title={<FormattedMessage id="routeAuth.title" />}
                message={<FormattedMessage id="routeAuth.message" />}
            >
                <Button link="/me" icon="arrow-left" iconColor="primary">
                    <FormattedMessage id="routeAuth.back" />
                </Button>
            </ErrorScreen>
        );
    } else {
        return element;
    }
};
